import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { Typography, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { hideModal } from 'state/actions';
import { MODAL, COLOR, SLIDESHOWMODALSTEP } from 'config/constants';
import { useAuth, useListing, useListingVideoTemplates } from 'hooks';
import { HvModal, HvButton } from 'components';
import { VideoTemplate } from 'models';
import { TemplateSelection } from './components';

const useStyles = makeStyles({
  title: {
    fontWeight: 'bold',
  },
  description: {
    fontSize: 14,
    marginBottom: 16,
    color: COLOR.DARK_BLUE,
  },
  cancelButton: {
    backgroundColor: 'white',
    marginRight: 20,
    color: '#00bdf2',
    border: '1px solid #00bdf2',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: 20,
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    marginBottom: 5,
  },
  reminderContent: {
    backgroundColor: COLOR.LIGHT_RED_CONTENT,
    padding: 10,
    borderRadius: 8,
    marginBottom: 10,
  },
  reminderText: {
    color: COLOR.RED,
  },
});
interface Props {
  setActiveStep: (_: number) => void;
  selectedTemplate: VideoTemplate;
  setSelectedTemplate: (_: VideoTemplate) => void;
}
function SlideshowTemplates({ setActiveStep, selectedTemplate, setSelectedTemplate }: Props) {
  const intl = useIntl();
  const styles = useStyles();
  const dispatch = useDispatch();
  const { token } = useAuth();
  const path = window.location.pathname;
  const arr = path.split('/');
  const listing_token = arr[arr.length - 1];
  const { listing } = useListing(listing_token);
  const { loadVideoTemplates } = useListingVideoTemplates(token, listing.id);
  const listing_video_picture_count = listing.pictures.filter((picture) => {
    return picture.included_in_video === true;
  }).length;

  const fmtSlideshow = intl.formatMessage({ id: 'deliver.video_slideshow.title' });
  const fmtSelectTheme = intl.formatMessage({ id: 'deliver.video_slideshow.selectTheme' });
  const fmtListingHas = intl.formatMessage({ id: 'deliver.video_slideshow.listingHas' });
  const fmtPhotos = intl.formatMessage({ id: 'deliver.video_slideshow.photos' });
  const fmtForBetterResult = intl.formatMessage({ id: 'deliver.video_slideshow.forBetterResult' });

  useEffect(() => {
    loadVideoTemplates();
  }, []);
  const onClose = () => {
    dispatch(hideModal(MODAL.SLIDESHOW));
  };

  const onNext = () => {
    setActiveStep(SLIDESHOWMODALSTEP.PICTURES);
  };
  const onSelectTemplate = (template) => {
    setSelectedTemplate(template);
  };
  const buttons = (
    <Box>
      <HvButton className={styles.cancelButton} onClick={onClose}>
        {intl.formatMessage({ id: 'deliver.photos.cancel' })}
      </HvButton>
      <HvButton disabled={!selectedTemplate} onClick={onNext}>
        {intl.formatMessage({ id: 'deliver.photos.next' })}
      </HvButton>
    </Box>
  );

  return (
    <HvModal title={fmtSlideshow} buttons={buttons} headerImage='slideshow' onClose={onClose}>
      <Typography className={styles.title}>{fmtSelectTheme}</Typography>
      <Typography className={styles.description}>
        {`${fmtListingHas} ${listing_video_picture_count} ${fmtPhotos}`}
      </Typography>
      {listing.centris_listing ? null : (
        <Box className={styles.reminderContent}>
          <Typography className={styles.reminderText}>{fmtForBetterResult}</Typography>
        </Box>
      )}
      <TemplateSelection selectedTemplate={selectedTemplate} onSelectTemplate={onSelectTemplate} />
    </HvModal>
  );
}
export default SlideshowTemplates;
